import { useMatches as useRouterMatches } from 'react-router'

import { RouteHandle } from '../types/route'

type MatchResult = {
  id: string
  pathname: string
  handle: RouteHandle
}

export const useMatches = useRouterMatches as () => MatchResult[]
